import React from "react";
import useObjectInput from "../../../hooks/useObjectInput";
import NestedParentHeader from "./NestedParentHeader";

// shows at the top of the page and displays all the parents of the selected object
// parents: list of parents title of the selected object
// showCompleteTree: function to toggle the complete tree state of the selected object
const GOIParentsHeader = ({ parents, showCompleteTree }) => {
  const { detailedErrorLog } = useObjectInput();
  const mainClassName = `px-10 border-all-dark all-parents ${
    parents?.length > 0 ? "flex-h-b" : "flex-h-e py-10"
  } ${detailedErrorLog?.length ? "parent-header-margin-top" : ""}`;

  return (
    <div className={mainClassName}>
      {parents?.length ? <NestedParentHeader parents={parents} /> : <></>}
      <div>
        <span className="clickable see-tree" onClick={showCompleteTree}>
          see tree
        </span>
      </div>
    </div>
  );
};

export default GOIParentsHeader;
